/** @format */

import Base from "@/api-services/base";
const BaseURL = `Colaboradores`;
import PeriodosNominas from "@/api-services/periodosNominas.service";
import { IsoDate2sFechaAmplia } from "@/api-services/LiFecha";
import { CopiaDocumentos, CopiaIngreso } from "@/Vistas/Personal/filtroDocumentos";

export default {
  GetsResponse: null,
  GetsResponseBorrados: null,
  Listado: [],
  // El adelanto desde caché va con la caché QUE CORRESPONDE. Estaba cruzado
  // —`Borrados` leía GetsResponse y viceversa, al revés de como se guardan más
  // abajo—, así que un select de activos recibía de golpe el listado de
  // borrados como si fueran sus opciones. Vistas/Personal/Select.vue reparte el
  // v-model contra esas opciones, de modo que todos los IDs quedaban fuera del
  // listado visible; la respuesta buena llegaba después, pero para entonces el
  // padre ya tenía el valor vaciado y guardar daba de baja a los líderes.
  getsSelect(Vista, Borrados, OnCorrecto, OnErroneo, OnFinalizado) {
    if (Borrados) {
      if (this.GetsResponseBorrados != null) OnCorrecto(this.GetsResponseBorrados);
    } else {
      if (this.GetsResponse != null) OnCorrecto(this.GetsResponse);
    }
    return Base.getsBaseSuscripcion(
      Vista,
      BaseURL,
      { PaginaLen: 5000, Borrados: Borrados },
      (response) => {
        if (Borrados) this.GetsResponseBorrados = response;
        else this.GetsResponse = response;
        this.Listado = response.data.listado;
        if (OnCorrecto != undefined) OnCorrecto(response);
      },
      OnErroneo,
      OnFinalizado
    );
  },
  TotalesPorGets(Vista, Agrupacion, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/TotalesPor/${Agrupacion}`,
      {},
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  // Configuración de vista de EDICIÓN de colaboradores: es donde el cliente renombra los
  // campos estándar (p.ej. dDireccion.Municipio -> "Población"), y de donde el cardex ya
  // toma sus etiquetas.
  //
  // Va por la ruta ConfigVistas y NO por `Colaboradores/ConfigVistaEdicion`, aunque esa
  // última parezca la natural: aquélla sólo pide sesión, mientras que ésta exige
  // eAccion.Avanzado y responde 401 a quien no lo tenga. Un 401 aquí no sería un error
  // local sino una expulsión —base.js navega a /login ante cualquier 401—, así que un
  // usuario de RH sin permisos avanzados se quedaría sin sesión a media alta.
  getConfigVistaEdicion(Vista, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`ConfigVistas/${BaseURL}/Edicion`);
    return Base.get(Vista, URL, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  putCamposLaborales(Vista, CamposLaborales, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/CamposLaborales`);
    return Base.put(Vista, URL, CamposLaborales, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  putCamposPersonales(Vista, CamposPersonales, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/CamposPersonales`);
    return Base.put(Vista, URL, CamposPersonales, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  putAutoServicioConfig(Vista, CamposLaborales, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/AutoServicioConfig`);
    return Base.put(Vista, URL, CamposLaborales, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  AniversariosGets(Vista, UbicacionID, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/Aniversarios/${UbicacionID}`,
      {},
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  //Suscripciones
  CumpleanosGets(Vista, UbicacionID, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/Cumpleanos/${UbicacionID}`,
      {},
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  //quita lo borrado
  patch(Vista, ID, Datos, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/${ID}`);
    return Base.patch(Vista, URL, Datos, {}, OnCorrecto, OnErroneo, OnFinalizado);
    //return Base.patchBaseSuscripcion(Vista, BaseURL, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado);
  },
  FiltroGets(Vista, Params, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(Vista, `${BaseURL}/Filtro`, Params, OnCorrecto, OnErroneo, OnFinalizado);
  },
  // Params se agrega a { PaginaLen: 5000 }: el modal de Personal manda { IncluirContratos: true } para
  // recibir el grupo ContratoEstados (S02 R10, R11; P15-I19). Los demás llamadores mandan {} o el mismo
  // PaginaLen, así que su petición no cambia (E44, E47).
  FiltroListadoGets(Vista, Params, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/Filtro/Listado`,
      Object.assign({ PaginaLen: 5000 }, Params),
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  gets(Vista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(Vista, BaseURL, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado);
  },
  GetsEnriquecido(Vista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/Enriquecido`,
      BaseGetsListado,
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  GetsOrganigrama(Vista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/Organigrama`,
      BaseGetsListado,
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  FotoURL(Colaborador) {
    var R = "/img/default-avatar.png";
    // console.debug(Colaborador);
    if (
      Colaborador != undefined &&
      Colaborador != null &&
      Colaborador.urlMiniatura != undefined &&
      Colaborador.urlMiniatura != null &&
      Colaborador.urlMiniatura != ""
    ) {
      R = Colaborador.urlMiniatura;
      //Parche para las importaciones de eClock
      R = R.replace("http://", "https://");
    }
    if (
      Colaborador != undefined &&
      Colaborador != null &&
      Colaborador.UrlMiniatura != undefined &&
      Colaborador.UrlMiniatura != null &&
      Colaborador.UrlMiniatura != ""
    ) {
      R = Colaborador.UrlMiniatura;
      //Parche para las importaciones de eClock
      R = R.replace("http://", "https://");
    }
    //console.debug(R);
    return R;
  },
  //Obtiene el archivo de layout para la suscripción activa
  InterfazGet(Vista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Interfaz`);
    if (OnCorrecto == null) {
      OnCorrecto = (response) => {
        Base.Response2FileDownload(response);
      };
    }
    return Base.get(Vista, URL, { responseType: "blob", params: BaseGetsListado }, OnCorrecto, OnErroneo, OnFinalizado);
  },
  InterfazPost(Vista, listado, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Interfaz`);
    return Base.post(Vista, URL, listado, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  //Obtiene un archivo en excel previamente configurado en la suscripción
  ExcelAvanzadoGets(Vista, Formato, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Excel/Avanzado/${Formato}`);
    if (OnCorrecto == null) {
      OnCorrecto = (response) => {
        Base.Response2FileDownload(response);
      };
    }
    return Base.get(Vista, URL, { responseType: "blob", params: BaseGetsListado }, OnCorrecto, OnErroneo, OnFinalizado);
  },

  //Obtiene un archivo en excel previamente configurado en la suscripción, con datos de filtro
  ExcelAvanzadoPut(
    Vista,
    Formato,
    //Modelo ColaboradoresExcelAvanzadoPut_Model
    Parametros,
    BaseGetsListado,
    OnCorrecto,
    OnErroneo,
    OnFinalizado
  ) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Excel/Avanzado/${Formato}`);
    if (OnCorrecto == null) {
      OnCorrecto = (response) => {
        Base.Response2FileDownload(response);
      };
    }
    return Base.put(
      Vista,
      URL,
      Parametros,
      { responseType: "blob", params: BaseGetsListado },
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  //Obtiene el archivo de layout para la suscripción activa
  ExcelGet(Vista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Excel`);
    if (OnCorrecto == null) {
      OnCorrecto = (response) => {
        Base.Response2FileDownload(response);
      };
    }
    return Base.get(Vista, URL, { responseType: "blob", params: BaseGetsListado }, OnCorrecto, OnErroneo, OnFinalizado);
  },
  //Obtiene la plantilla de importaicón para la suscripción activa
  ExcelPlantillaGet(Vista, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Excel/Plantilla`);
    return Base.get(
      Vista,
      URL,
      { responseType: "blob", params: { EsXls: false } },
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  //Importa un archivo de excel
  ExcelPlantillaPatch(Vista, Archivo, OnUploadProgress, OnCorrecto, OnErroneo, OnFinalizado) {
    let formData = new FormData();
    formData.append("ArchivoExcel", Archivo);
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Excel`);
    return Base.patch(
      Vista,
      URL,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: OnUploadProgress,
      },
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  //Obtiene la plantilla de importaicón de historicos para la suscripción activa
  ExcelHistoricosPlantillaGet(Vista, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Excel/Historicos/Plantilla`);
    return Base.get(
      Vista,
      URL,
      { responseType: "blob", params: { EsXls: false } },
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  //Importa un archivo de excel de historicos
  ExcelHistoricosPatch(Vista, Archivo, OnUploadProgress, OnCorrecto, OnErroneo, OnFinalizado) {
    let formData = new FormData();
    formData.append("ArchivoExcel", Archivo);
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Excel/Historicos`);
    return Base.patch(
      Vista,
      URL,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: OnUploadProgress,
      },
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },

  /*
    Genera y descarga una plantilla Excel específica para la importación de cambios históricos en los datos de colaboradores. Esta plantilla permite registrar modificaciones pasadas con fechas específicas, útil para migraciones de datos o correcciones retroactivas.

Campos principales:

LinkID del colaborador
Fecha del cambio
Campo modificado y nuevo valor*/
  ExcelHistoricosPlantillaGet(Vista, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Excel/Historicos/Plantilla`);
    return Base.get(
      Vista,
      URL,
      { responseType: "blob", params: { EsXls: false } },
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  /*Permite importar cambios históricos en los datos de colaboradores (Upsert). La operación:

Agrega nuevos registros históricos si no existen
Actualiza registros existentes cuando encuentra coincidencias
Solo modifica campos que contienen valores en el Excel
Requiere permiso de nivel Avanzado en la suscripción. El archivo se almacena automáticamente como respaldo antes de procesarse.
*/
  ExcelHistoricosPatch(Vista, Archivo, OnUploadProgress, OnCorrecto, OnErroneo, OnFinalizado) {
    let formData = new FormData();
    formData.append("ArchivoExcel", Archivo);
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Excel/Historicos`);
    return Base.patch(
      Vista,
      URL,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: OnUploadProgress,
      },
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  /*Genera y descarga una plantilla Excel con las columnas necesarias para la importación masiva de sueldos de colaboradores.

Campos principales:

LinkID del colaborador*/

  ExcelSueldoPlantillaGet(Vista, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Excel/Sueldo/Plantilla`);
    return Base.get(
      Vista,
      URL,
      { responseType: "blob", params: { EsXls: false } },
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  /*
  Permite la importación masiva de información salarial de colaboradores desde un archivo Excel. La operación soporta:

Sueldos básicos: SueldoDiario, SueldoMensual, SueldoNetoDiario, SueldoNetoMensual
Sueldos variables: SueldoVariableDiario, SueldoVariableMensual, SueldoHoraExtra
IMSS/INFONAVIT: FactorImss, SdiImss, SdiInfonavit
Conceptos opcionales: Premios, bonos, vales, apoyos (según configuración)
Campos de seguimiento: Motivo, Comentarios (según configuración de auditoría)
Comportamiento:

Busca colaboradores por LinkID
Solo actualiza campos que contienen valores en el Excel
Genera auditoría con campos de seguimiento configurados
Requiere permiso de nivel Avanzado en la suscripción. El archivo se almacena automáticamente como respaldo antes de procesarse.*/

  ExcelSueldoPatch(Vista, Archivo, OnUploadProgress, OnCorrecto, OnErroneo, OnFinalizado) {
    let formData = new FormData();
    formData.append("ArchivoExcel", Archivo);
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Excel/Sueldo`);
    return Base.patch(
      Vista,
      URL,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: OnUploadProgress,
      },
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  //Importa desde interfaz
  InterfazPatch(Vista, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Interfaz`);
    return Base.patch(Vista, URL, {}, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },

  InterfazAvanzadaConfigGet(Vista, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/Interfaz/Avanzada/Config`,
      {},
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  //Importa desde interfaz Avanzada
  InterfazAvanzadaPatch(Vista, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Interfaz/Avanzada`);
    return Base.patch(Vista, URL, {}, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  InterfazCorreoPost(Vista, Cuerpo, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = `${BaseURL}/Interfaz/Correo`;
    return Base.postBaseSuscripcion(Vista, URL, Cuerpo, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  //Envia una foto para su identificacion
  IdentificarPatch(Vista, Archivo, OnUploadProgress, OnCorrecto, OnErroneo, OnFinalizado) {
    let formData = new FormData();
    formData.append("Foto", Archivo);
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Identificar`);
    return Base.patch(
      Vista,
      URL,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: Base.TiempoEsperaIdentificacion,
        onUploadProgress: OnUploadProgress,
      },
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  //Agrega o actualiza la foto de un colaborador
  FotoPatch(Vista, ID, Orden, Archivo, OnUploadProgress, OnCorrecto, OnErroneo, OnFinalizado) {
    let formData = new FormData();
    formData.append("Foto", Archivo);
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/${ID}/Foto?Orden=${Orden}`);
    return Base.patch(
      Vista,
      URL,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: OnUploadProgress,
      },
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  put(Vista, ID, Datos, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/${ID}`);
    return Base.put(Vista, URL, Datos, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  postClones(Vista, ID, Datos, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/${ID}/Clones`);
    return Base.post(Vista, URL, Datos, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  post(Vista, Datos, OnCorrecto, OnErroneo, OnFinalizado, SuscripcionID) {
    return Base.postBaseSuscripcion(Vista, BaseURL, Datos, {}, OnCorrecto, OnErroneo, OnFinalizado, SuscripcionID);
  },
  get(Vista, id, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(Vista, `${BaseURL}/${id}`, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },

  delete(Vista, ID, Datos, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/${ID}/Borrar`);
    return Base.put(Vista, URL, Datos, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  EnviarBienvenida(Vista, ID, Datos, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/${ID}/EnviarBienvenida`);
    return Base.post(Vista, URL, Datos, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  PostSesion(Vista, Datos, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Sesiones`);
    return Base.post(Vista, URL, Datos, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  getAceptarInvitacion(Vista, SuscripcionID, ColaboradorID, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = `${Base.URL}/Suscripciones/${SuscripcionID}/${BaseURL}/${ColaboradorID}/AceptarInvitacion`;
    //  console.debug(URL);
    return Base.get(Vista, URL, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  getInvitacion(Vista, ColaboradorID, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/${ColaboradorID}/Invitacion`);
    return Base.get(Vista, URL, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  getHome(Vista, id, Parametros, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(Vista, `${BaseURL}/${id}/Home`, Parametros, OnCorrecto, OnErroneo, OnFinalizado);
  },
  GetHuellas(Vista, ColaboradorID, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/${ColaboradorID}/Huellas`,
      {},
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  getByCURP(Vista, CURP, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(Vista, `${BaseURL}/CURP/${CURP}`, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  MotivosBaja() {
    return [
      {
        label: "Separación voluntaria, mejor oferta económica/desarrollo",
        value: "Crecimiento",
      },
      {
        label: "Separación voluntaria, ambiente de trabajo",
        value: "Ambiente",
      },
      { label: "Separación voluntaria, relación con jefe", value: "Jefe" },
      {
        label: "Separación voluntaria, cambio de residencia o le queda lejos",
        value: "Ubicacion",
      },
      {
        label: "Rescisión de contrato, no es la persona para el puesto nunca perteneció",
        value: "Encaje",
      },
      {
        label: "Rescisión de contrato Término de contrato",
        value: "FinContrato",
      },

      { label: "Rescisión de contrato Abandono el empleo", value: "Abandono" },
      { label: "Rescisión de contrato Bajo desempeño", value: "Desempeno" },
      { label: "Se jubiló", value: "Jubilacion" },

      { label: "Otro", value: "Otro" },
      { label: "Desconocido", value: "Desconocido" },
    ];
  },
  MotivoBaja(value) {
    var R = this.MotivosBaja().filter((x) => x.value == value);
    if (R.length > 0) return R[0].label;
    return "Desconocido";
  },
  Periodo: {
    ListadoColaboradores: [],
    Filtros: null,
    valorFiltro: null,
    periodo: null,
    Colaboradores: [],
    PeriodoTexto: "",
    // P15-I19 (B1): el «Filtro Aplicado» sin las partes del bloque «Documentos» ni los grupos con nombre,
    // como lo guardaba el modal antes; null si lo guardó una pantalla sin el bloque (PeriodoTexto ya es ése).
    PeriodoTextoSinDocumentos: null,
    Filtro: "",
    // El bloque «Documentos» de Personal y el grupo ContratoEstados que lo muestra (S02 R11; P15-I19).
    // Sólo los usa el modal con mostrarContratos.
    Documentos: null,
    GrupoContratos: null,
    // «Fecha de ingreso» de Personal (P15-I114, S02 R25): fuera del bloque y sin permiso; también sólo
    // para el modal con mostrarContratos.
    Ingreso: null,
    ElFiltro: {
      Borrados: false,
      PaginaNo: 0,
      PaginaLen: 50,
      filtro: "",
    },
    //La ultima fecha obtenida de los periodos de nómina
    Hoy: null,
    PeriodosNominas: [],
  },
  PeriodoValoresObtener(Vista, ObtenerPeriodosNominas) {
    if (Vista) {
      Vista.ListadoColaboradores = this.Periodo.ListadoColaboradores;
      Vista.Filtros = this.Periodo.Filtros;
      Vista.valorFiltro = this.Periodo.valorFiltro;
      Vista.periodo = this.Periodo.periodo;
      Vista.Colaboradores = this.Periodo.Colaboradores;
      // Una pantalla sin el bloque nunca nombra un filtro de contrato que no aplica (B1): recibe el texto
      // de siempre, no el de Personal con «Contrato: …» o «Firma: …».
      Vista.PeriodoTexto =
        Vista.mostrarContratos !== true && this.Periodo.PeriodoTextoSinDocumentos != null
          ? this.Periodo.PeriodoTextoSinDocumentos
          : this.Periodo.PeriodoTexto;
      Vista.Filtro = this.Periodo.Filtro;
      // Sólo el modal de Personal (mostrarContratos): las demás vistas comparten este estado, pero no el bloque.
      if (Vista.mostrarContratos === true) {
        Vista.Documentos = CopiaDocumentos(this.Periodo.Documentos);
        Vista.GrupoContratos = this.Periodo.GrupoContratos;
        Vista.Ingreso = CopiaIngreso(this.Periodo.Ingreso);
      }
      if (ObtenerPeriodosNominas) {
        var Hoy = IsoDate2sFechaAmplia();
        if (Hoy != this.Periodo.Hoy) {
          PeriodosNominas.gets(Vista, { Activos: true }, (response) => {
            this.Periodo.PeriodosNominas = response.data.listado;
            //      console.debug(response);
            Vista.PeriodosNominas = this.Periodo.PeriodosNominas;
            this.Periodo.Hoy = Hoy;
          });
        } else Vista.PeriodosNominas = this.Periodo.PeriodosNominas;
      }
    }
    return this.Periodo.ElFiltro;
  },
  PeriodoValoresGuarda(Vista, ElFiltro) {
    this.Periodo.ListadoColaboradores = Vista.ListadoColaboradores;
    this.Periodo.Filtros = Vista.Filtros;
    this.Periodo.valorFiltro = Vista.valorFiltro;
    this.Periodo.periodo = Vista.periodo;
    this.Periodo.Colaboradores = Vista.Colaboradores;
    this.Periodo.PeriodoTexto = Vista.PeriodoTexto;
    this.Periodo.Filtro = Vista.Filtro;
    // ElFiltro es el mismo para todas las vistas: si lo guarda otra, ya no lleva el bloque de Personal.
    if (Vista.mostrarContratos === true) {
      this.Periodo.Documentos = CopiaDocumentos(Vista.Documentos);
      this.Periodo.GrupoContratos = Vista.GrupoContratos;
      this.Periodo.Ingreso = CopiaIngreso(Vista.Ingreso);
      this.Periodo.PeriodoTextoSinDocumentos =
        Vista.PeriodoTextoSinDocumentos != null ? Vista.PeriodoTextoSinDocumentos : Vista.PeriodoTexto;
    } else {
      this.Periodo.Documentos = null;
      this.Periodo.Ingreso = null;
      this.Periodo.PeriodoTextoSinDocumentos = null;
    }
    this.Periodo.ElFiltro = ElFiltro;
  },
  patchAsignaFoto(Vista, ID, Orden, Datos, OnCorrecto, OnErroneo, OnFinalizado) {
    let URL = Base.ObtenURLSuscripcion(`${BaseURL}/${ID}/Fotos/${Orden}/Url`);
    return Base.patch(Vista, URL, Datos, OnCorrecto, OnErroneo, OnFinalizado);
  },

  AditoriaBorrado(Vista, ID, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/${ID}/Auditorias/Borrado`,
      {},
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  getUsuario(Vista, ID, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(Vista, `${BaseURL}/${ID}/Usuarios`, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  putUsuario(Vista, ID, Datos, OnCorrecto, OnErroneo, OnFinalizado) {
    let URL = Base.ObtenURLSuscripcion(`${BaseURL}/${ID}/Usuarios`);
    return Base.put(Vista, URL, Datos, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },

  putLideres(Vista, ID, Datos, OnCorrecto, OnErroneo, OnFinalizado) {
    let URL = Base.ObtenURLSuscripcion(`${BaseURL}/${ID}/Lideres`);
    return Base.put(Vista, URL, Datos, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
};
